import {getRequest, URL_SERVER} from './../requests'


export async function getPendingOffers(token){
    try {
        return await getRequest(URL_SERVER + '/offers/pending', token)
    } catch (error) {
        console.error(error);
    }
}